// @flow
export { default } from './AppActivity';
